import React from 'react';

import { Box, HStack, Text, VStack } from '@betterment/samba-react';

type Step = {
  label: string;
};

interface RolloverProgressStepsProps {
  steps: Step[];
  currentStep: number;
}

const STEP_HEIGHT = 'size.400';
const BAR_WIDTH = 'size.200';
const DOT_SIZE = 'size.50';

const BarPortion = ({ active }: { active: boolean }) => (
  <Box
    css={{
      backgroundColor: active ? 'background.info.strong' : 'background.neutral',
      width: BAR_WIDTH,
      height: STEP_HEIGHT,
      _first: { backgroundColor: 'background.transparent' },
      _last: { backgroundColor: 'background.transparent' },
    }}
  />
);

const Dot = ({ active }: { active: boolean }) => (
  <Box
    css={{
      width: BAR_WIDTH,
      height: BAR_WIDTH,
      borderRadius: '50%',
      backgroundColor: active ? 'background.info.strong' : 'background.neutral',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      css={{
        backgroundColor: active ? 'background.surface' : 'black',
        width: DOT_SIZE,
        height: DOT_SIZE,
        borderRadius: '50%',
      }}
    />
  </Box>
);

const RolloverProgressSteps: React.FC<RolloverProgressStepsProps> = ({ steps, currentStep }) => {
  return (
    <VStack>
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;

        return (
          <React.Fragment key={step.label}>
            <BarPortion active={isCompleted || isCurrent} />
            <HStack
              css={{
                height: 0,
                transform: 'translateY(-50%)',
                alignItems: 'center',
                overflow: 'visible',
                gap: 'space.150',
              }}
            >
              <Dot active={isCompleted || isCurrent} />
              <Text variant="text100" color={isCompleted || isCurrent ? 'text' : 'text.weak'}>
                {step.label}
              </Text>
            </HStack>
            <BarPortion active={isCompleted} />
          </React.Fragment>
        );
      })}
    </VStack>
  );
};

export default RolloverProgressSteps;
